var _excluded = ["className", "children", "hasBorder", "isFlushPadding", "hasCloseButton", "variant", "isInverse", "size", "title", "subTitle", "vehicleImage", "headingLevel", "utils"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import nodeOfType from '../../../../utilities/types-of-node';
import { ModalToggleContext } from '../../context/modal-context';
import Icon from '../../../icon';
import VehicleImage from '../../../vehicle-image';
import Type from '../../../type';
import InverseContext from '../../../../utilities/inverse-context';
import StyledModalHeader from './modal.header.styles';
import StyledModalHeaderInner from './styles/modal.header.inner.styles';
import StyledModalHeaderTitle from './styles/modal.header.title.styles';
import StyledModalHeaderSubtitle from './styles/modal.header.subtitle.styles';
import StyledModalHeaderChildren from './styles/modal.header.children.styles';
import StyledModalHeaderButton from './styles/modal.header.button.styles';
var modalHeaderPropTypes = {
  /** Child elements to be rendered inside of the modal header */
  children: PropTypes.node,
  /** Add custom CSS classes to component */
  className: PropTypes.string,
  /** Adds a border to the bottom of the header */
  hasBorder: PropTypes.bool,
  /** To remove the left and right padding */
  isFlushPadding: PropTypes.bool,
  /** Show close button on the right */
  hasCloseButton: PropTypes.bool,
  /** Adds larger title size **/
  size: PropTypes.oneOf(['md', 'lg']),
  /** Style of the modal header subTitle */
  variant: PropTypes.oneOf(['default', 'information', 'success', 'protection', 'community']),
  /** Modal header with dark background. */
  isInverse: PropTypes.bool,
  /** Modal Header title */
  title: PropTypes.node,
  /** Modal Header subtitle */
  subTitle: PropTypes.oneOfType([PropTypes.string, nodeOfType([Type])]),
  /** Adds an overlapping vehicle image to the subheader */
  vehicleImage: PropTypes.object,
  /** Render headline with a semantic elements */
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  /** Add utility objects for styling */
  utils: PropTypes.object
};
var modalHeaderDefaultProps = {
  className: '',
  children: /*#__PURE__*/React.createElement("div", null),
  hasBorder: true,
  isFlushPadding: false,
  hasCloseButton: true,
  variant: 'default',
  isInverse: false,
  title: '',
  size: 'md',
  subTitle: '',
  vehicleImage: null,
  headingLevel: 1,
  utils: {}
};
function renderVehicleImage(props) {
  return /*#__PURE__*/React.createElement(VehicleImage, _extends({}, props, {
    size: "md"
  }));
}
var ModalHeader = function ModalHeader(props) {
  var className = props.className,
    children = props.children,
    hasBorder = props.hasBorder,
    isFlushPadding = props.isFlushPadding,
    hasCloseButton = props.hasCloseButton,
    variant = props.variant,
    isInverse = props.isInverse,
    size = props.size,
    title = props.title,
    subTitle = props.subTitle,
    vehicleImage = props.vehicleImage,
    headingLevel = props.headingLevel,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var _useContext = useContext(ModalToggleContext),
    onClickTrigger = _useContext.onClickTrigger,
    titleId = _useContext.titleId,
    closeId = _useContext.closeId;
  return /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: isInverse
  }, /*#__PURE__*/React.createElement(StyledModalHeader, _extends({}, other, {
    className: className,
    variant: variant,
    isFlushPadding: isFlushPadding,
    hasBorder: hasBorder,
    isInverse: isInverse,
    utils: utils
  }), /*#__PURE__*/React.createElement(StyledModalHeaderInner, {
    className: className,
    title: title
  }, /*#__PURE__*/React.createElement(StyledModalHeaderTitle, {
    id: titleId
  }, subTitle && /*#__PURE__*/React.createElement(StyledModalHeaderSubtitle, null, /*#__PURE__*/React.createElement(Type, {
    size: size === 'md' ? 's' : 'm',
    variant: variant,
    isInverse: isInverse,
    weight: "semibold"
  }, subTitle)), title && /*#__PURE__*/React.createElement(Type, {
    element: "h".concat(headingLevel),
    size: size === 'md' ? 'xl' : '3xl',
    isInverse: isInverse,
    variant: "light",
    weight: "semibold"
  }, title)), (vehicleImage || children) && /*#__PURE__*/React.createElement(StyledModalHeaderChildren, null, vehicleImage && renderVehicleImage(vehicleImage), children)), hasCloseButton && /*#__PURE__*/React.createElement(StyledModalHeaderButton, {
    id: closeId,
    type: "button",
    isHollow: true,
    isPrimary: true,
    isInverse: isInverse,
    hasIconOnly: true,
    onClick: onClickTrigger,
    "aria-label": 'Close ' + title + ' Dialog'
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "cross",
    size: 1,
    alt: "Close"
  }))));
};
ModalHeader.propTypes = modalHeaderPropTypes;
ModalHeader.defaultProps = modalHeaderDefaultProps;
ModalHeader.displayName = 'Modal.Header';
export default ModalHeader;